export function returnByteWithNotation(size:number|undefined) {
    if (size == undefined) {
        return "--";
      } else if (size != undefined) {
        let repetion: number = 0;
        let bytes: number = size;

        while (bytes >= 1024 && repetion < 4) {
          bytes = bytes / 1024;
          repetion = repetion + 1;
        }

        if (repetion == 0) {
          return (
            Math.round(bytes).toLocaleString(undefined, {
              maximumFractionDigits: 2,
            }) + " Bytes"
          );
        } else if (repetion == 1) {
          return (
            Math.round(bytes).toLocaleString(undefined, {
              maximumFractionDigits: 2,
            }) + " KB"
          );
        } else if (repetion == 2) {
          return (
            Math.round(bytes).toLocaleString(undefined, {
              maximumFractionDigits: 2,
            }) + " MB"
          );
        } else if (repetion == 3) {
          return (
            bytes.toFixed(1).toString() + " GB"
          );
        } else if (repetion == 4) {
          return (
            bytes.toFixed(1).toString() + " TB"
          );
        }
      }
}